var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 21c0 .552-.448 1-1 1s-1-.448-1-1c.006-2.548-1.598-4.82-4-5.67l-.48-.14-.12-.06c-.54-.134-.926-.61-.947-1.166-.021-.556.328-1.06.857-1.234h.06c1.31-.593 2.015-2.032 1.68-3.43C19.716 7.9 18.436 6.935 17 7c-.552 0-1-.448-1-1s.448-1 1-1c2.074 0 3.933 1.28 4.672 3.218.74 1.938.205 4.13-1.342 5.512 2.844 1.302 4.668 4.142 4.67 7.27zm-6 0c0 .552-.448 1-1 1s-1-.448-1-1c0-3.314-2.686-6-6-6s-6 2.686-6 6c0 .552-.448 1-1 1s-1-.448-1-1c.002-3.128 1.826-5.968 4.67-7.27-1.547-1.381-2.08-3.574-1.342-5.512C7.068 6.281 8.926 5 11 5s3.933 1.28 4.672 3.218c.739 1.938.205 4.13-1.342 5.512 2.844 1.302 4.668 4.142 4.67 7.27zm-5-11c0-1.657-1.343-3-3-3s-3 1.343-3 3 1.343 3 3 3 3-1.343 3-3z",
    transform: "translate(-20 -253) translate(20 253)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.67e32a87603f16161a76c357ea4693d3.svg";
export { ForwardRef as ReactComponent };